import api from './api';

export const budgetSetupService = {
  // Versions
  getVersions: async () => {
    const response = await api.get('/budget-setup/versions');
    return response.data;
  },
  createVersion: async (data) => {
    const response = await api.post('/budget-setup/versions', data);
    return response.data;
  },
  updateVersion: async (id, data) => {
    const response = await api.put(`/budget-setup/versions/${id}`, data);
    return response.data;
  },
  deleteVersion: async (id) => {
    const response = await api.delete(`/budget-setup/versions/${id}`);
    return response.data;
  },

  // GL Lines (for the next step)
  getReferenceData: async () => {
    const response = await api.get('/budget-setup/reference-data');
    return response.data;
  },
  getGLLines: async (versionId) => {
    const response = await api.get(`/budget-setup/gl-lines/${versionId}`);
    return response.data;
  },
  addGLLines: async (payload) => {
    const response = await api.post('/budget-setup/gl-lines', payload);
    return response.data;
  },
  deleteGLLines: async (lineIds) => {
    // Axios requires data payload for DELETE requests to be wrapped in a 'data' config property
    const response = await api.delete('/budget-setup/gl-lines', { data: { line_ids: lineIds } });
    return response.data;
  },

  // Currencies (scoped to a budget version). `data`/params must carry version_id.
  getCurrencies: async (versionId) => {
    const response = await api.get('/budget-setup/currencies', { params: { versionId } });
    return response.data;
  },
  addCurrency: async (data) => {
    const response = await api.post('/budget-setup/currencies', data);
    return response.data;
  },
  updateCurrency: async (code, data) => {
    const response = await api.put(`/budget-setup/currencies/${code}`, data);
    return response.data;
  },
  setBaseCurrency: async (code, versionId) => {
    const response = await api.put(`/budget-setup/currencies/${code}/base`, { version_id: versionId });
    return response.data;
  },
  deleteCurrency: async (code, versionId) => {
    const response = await api.delete(`/budget-setup/currencies/${code}`, { params: { versionId } });
    return response.data;
  }
};

// NOTE: volumes moved to volumeService.js (/api/volumes) and selling prices to
// sellingPriceService.js (/api/selling-prices) — see the matching backend split.